var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, when, makeObservable } from 'mobx';
import { bound } from '../../../utils/decorators/basic';
import { runtime } from '../../runtime/Runtime';
import { ChannelName, PlayStatus } from '../../learnware/LearnwareEnums';
import { str_replace } from '../../../utils/helper/helper_string';
import { VideoIntent } from '../intent/video/VideoIntent';
import { AudioIntent } from '../intent/audio/AudioIntent';
export class MediaReception {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get media() {
        return this.parent;
    }
    get app() {
        return this.media.app;
    }
    async playMediumFromContext(triggerAt) {
        const { availableMediaSequence } = triggerAt.activeOf;
        if (!availableMediaSequence)
            return; // don't play when condition is false
        const mediumLabel = str_replace('_auto', '', availableMediaSequence.trait.value); // _auto is legacy
        const attachedMedium = triggerAt.context.mediaContext[mediumLabel];
        await this.playMedium(attachedMedium, triggerAt);
    }
    async playMedium(attachedMedium, triggerAt) {
        if (!attachedMedium || !attachedMedium.trait.value) {
            console.log('Kein Medium');
            return;
        }
        if (attachedMedium.trait.key === 'sound') {
            await this.playSound(attachedMedium, triggerAt);
        }
        if (attachedMedium.trait.key === 'video') {
            await this.playVideo(attachedMedium, triggerAt);
        }
    }
    async ensureMediaLibs() {
        if (!runtime.availablePackages.Defer) {
            await when(() => !!runtime.streamedPackages.Defer);
        }
        await runtime.solidBrowserRuntime.browserIncludes.includeJSFileOnce('/lib/howler/dist/howler.core.min.js');
    }
    async playVideo(attachedVideo, triggerAt) {
        await this.ensureMediaLibs();
        if (!attachedVideo || !attachedVideo.trait.value) {
            console.log('Keine Video-Datei');
            return;
        }
        const intent = new VideoIntent({
            triggerAt,
            attachedVideo,
            app: this.app,
        });
        this.queueIntent(intent, triggerAt);
    }
    async playSound(attachedSound, triggerAt) {
        await this.ensureMediaLibs();
        if (!attachedSound || !attachedSound.snd) {
            console.log('Keine Sound-Datei');
            return;
        }
        const intent = new AudioIntent({
            attachedSound,
            triggerAt,
            app: this.app,
        });
        this.queueIntent(intent, triggerAt);
    }
    queueIntent(intent, triggerAt) {
        if (!intent.medFile) {
            console.log('Media Intent has no playableFile');
            return;
        }
        intent.intentSettings.fromAspect(intent.attachedMedium.core);
        if (triggerAt) {
            if (triggerAt.atOf.availableMediaSequence) {
                intent.intentSettings.fromAspect(triggerAt.atOf.availableMediaSequence.core);
            }
            intent.intentSettings.fromAspect(triggerAt.core);
        }
        if (this.app.user && this.app.user.userStore.isSpeakerMuted) {
            if (intent.intentSettings.playbackChannel === ChannelName.Voice) {
                return;
            }
        }
        if (this.app.appInfo.isUserCurrentlyEditing && this.app.solidEdit.editModal.editItem) {
            // do not play files while modal editing
            return;
        }
        // abort stale intents from previous questions
        this.app.mediaPlayer.intents
            .filter(intent => [PlayStatus.Pending, PlayStatus.Go, PlayStatus.Playing].includes(intent.playStatus) && intent.questionId !== this.app.questionId)
            .forEach(intent => {
            console.log('abort stale intent from previous question');
            intent.playStatus = PlayStatus.Aborted;
        });
        // do not schedule if is already playing
        if (intent.intentSettings.playbackAbortConditions.includes('isAlreadyPlaying')) {
            if (this.app.mediaPlayer.playerIntents.playingStartedAndPendingIntents.find(playingIntent => playingIntent.medFile === intent.medFile)) {
                return;
            }
        }
        intent.intentSettings.playbackAbortRunning.forEach(channelName => {
            this.app.mediaPlayer.playerChannels.getChannel(channelName).intentsByState.playingIntents.forEach(playingIntent => {
                playingIntent.intentActions.abort();
                playingIntent.wasAbortedBy = intent;
            });
        });
        intent.intentSettings.playbackAbortQueued.forEach(channelName => {
            this.app.mediaPlayer.playerChannels.getChannel(channelName).intentsByState.pendingIntents.forEach(playingIntent => {
                playingIntent.intentActions.abort();
                playingIntent.wasAbortedBy = intent;
            });
        });
        this.app.mediaPlayer.intents.unshift(intent);
    }
}
__decorate([
    bound
], MediaReception.prototype, "playMediumFromContext", null);
__decorate([
    bound
], MediaReception.prototype, "playMedium", null);
__decorate([
    bound
], MediaReception.prototype, "playVideo", null);
__decorate([
    bound
], MediaReception.prototype, "playSound", null);
__decorate([
    action.bound
], MediaReception.prototype, "queueIntent", null);
